import React, { useEffect, useState } from 'react'

// Component
import Header from '../components/Header'
import LeagueStandings from '../components/LeagueStandings'
import PlayerRanking from '../components/PlayerRanking'
import RollingNewsFeed from '../components/RollingNewsFeed'
import TransactionTracker from '../components/TransactionTracker'
import { getProfessionalLeagueRanks } from '../redux'
import UserLog from '../components/UserLog'
import DraftOrder from '../components/DraftOrder'
import HeadingAndDate from '../components/Pagination/HeadingAndDate'
import MainHeader from '../components/MainHeader'

const League = () => {
  const [ranks, setRanks] = useState(null)

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    let data = await getProfessionalLeagueRanks()
    setRanks(data)
  }

  return (
    <div className='league_container_n1'>
      <MainHeader />

      <section className='league_details_container'>
        <div className='left'>
          <LeagueStandings data={ranks?.teamRanks} />
        </div>
        <div className='center'>
          <DraftOrder />
          <RollingNewsFeed />
          <TransactionTracker />
        </div>
        <div className='right'>
          <UserLog data={['', '', '', '', '', '', '', '']} />
          <PlayerRanking data={ranks?.playerRanks} />
        </div>
      </section>
    </div>
  )
}

export default League
